<script lang="ts">
import { defineComponent, h, inject, unref } from 'vue';

import { CdsTransitionExpand } from '@components/transitions';
import { classNames } from '@components/utils';

import { makeLazyProps, useLazy, useRender } from '../../composable';

import { CdsExpandablePanelsGroupSymbol } from './CdsExpandablePanels.vue';

export const componentName = 'CdsExpandablePanelContent';
export default defineComponent({
  name: componentName,
  props: {
    ...makeLazyProps()
  },
  setup(props, { slots, expose }) {
    const panel = inject(CdsExpandablePanelsGroupSymbol);

    if (!panel) throw new Error('[CDS] cds-expandable-panel-content needs to be placed inside cds-expandable-panel');

    const { hasContent } = useLazy(props, panel.isSelected);

    useRender(() =>
      h(
        CdsTransitionExpand,
        {},
        {
          default: () => [
            unref(panel.isSelected) &&
              h(
                'div',
                {
                  class: 'cds-expandable-panel__content'
                },
                [
                  slots.default &&
                    hasContent &&
                    h(
                      'div',
                      {
                        class: classNames('cds-expandable-panel__content-wrapper')
                      },
                      [slots.default?.()]
                    )
                ]
              )
          ]
        }
      )
    );

    expose({
      ...panel
    });

    return {};
  }
});
</script>
